import { isEqual } from 'lodash-es';

const NULLISH = new Set([null, undefined, '']);

export function hasDifferences(base, other, attrs) {
  return attrs.some((attr) => {
    if (NULLISH.has(base[attr]) && NULLISH.has(other[attr])) return false;
    return !isEqual(base[attr], other[attr]);
  });
}
